<div class="upload-recording-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'RECORDINGS.UPLOAD.TITLE' | translate }}</span>
		<button mat-icon-button (click)="cancel()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="form" (ngSubmit)="submit()">
			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'RECORDINGS.MEDIUM' | translate }}</mat-label>
					<mat-select formControlName="mediumId">
						@for (medium of mediums; track medium.id) {
						<mat-option [value]="medium.id">{{ medium.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row date-time-row">
				<mat-form-field class="date-field pe-1">
					<mat-label>{{ 'RECORDINGS.UPLOAD.SCHEDULED_DATE' | translate }}</mat-label>
					<input matInput [matDatepicker]="scheduledDatePicker" formControlName="scheduledDate" />
					<mat-datepicker-toggle matIconSuffix [for]="scheduledDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #scheduledDatePicker></mat-datepicker>
				</mat-form-field>

				<mat-form-field class="hour-field pe-1">
					<mat-label>{{ 'RECORDINGS.UPLOAD.HOUR' | translate }}</mat-label>
					<mat-select formControlName="hour">
						@for (hour of hours; track hour) {
						<mat-option [value]="hour">{{ hour }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field class="minute-field">
					<mat-label>{{ 'RECORDINGS.UPLOAD.MINUTE' | translate }}</mat-label>
					<mat-select formControlName="minute">
						@for (minute of minutes; track minute) {
						<mat-option [value]="minute">{{ minute }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="row pb-2 upload-mode-toggle">
				<button type="button" class="mode-btn" [class.active]="uploadMode === 'FILE'" (click)="setUploadMode('FILE')">
					{{ 'RECORDINGS.UPLOAD.MODE_FILE' | translate }}
				</button>
				<button type="button" class="mode-btn" [class.active]="uploadMode === 'LINK'" (click)="setUploadMode('LINK')">
					{{ 'RECORDINGS.UPLOAD.MODE_LINK' | translate }}
				</button>
			</div>

			@if (uploadMode === 'FILE') {
			<div class="row pb-2">
				<label class="file-label">{{ 'RECORDINGS.UPLOAD.FILE' | translate }}</label>
				<input type="file" accept=".mp4,.ts,.mkv,.mov" (change)="onFileSelected($event)" />
				@if (selectedFile) {
				<span class="selected-file">{{ selectedFile.name }}</span>
				}
				@if (fileError) {
				<span class="file-error">{{ fileError }}</span>
				}
			</div>
			} @else {
			<div class="row pb-2">
				<mat-form-field class="w-100">
					<mat-label>{{ 'RECORDINGS.UPLOAD.LINK' | translate }}</mat-label>
					<input matInput type="text" formControlName="videoLink" placeholder="https://..." />
					<mat-error *ngIf="form.controls['videoLink'].hasError('pattern')">
						{{ 'RECORDINGS.UPLOAD.LINK_INVALID' | translate }}
					</mat-error>
				</mat-form-field>
				<span class="link-hint muted">{{ 'RECORDINGS.UPLOAD.LINK_HINT' | translate }}</span>
			</div>
			}
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button
				mat-flat-button
				type="button"
				color="primary"
				(click)="submit()"
				[disabled]="form.invalid || (uploadMode === 'FILE' ? !selectedFile : !form.value.videoLink?.trim())">
				{{ 'RECORDINGS.UPLOAD.SUBMIT' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="cancel()">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
